var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"logo-loading-container"},[_c('div',{staticClass:"loading-mask"},[_c('div',{staticClass:"logo-wrapper"},[_c('img',{staticClass:"logo",attrs:{"src":require("../../logo.png"),"alt":"Logo"}}),_c('div',{staticClass:"loading-circle"})])])])
}]

export { render, staticRenderFns }